import { render, staticRenderFns } from "./FormularioNuevo.vue?vue&type=template&id=dde85e94"
import script from "../../components/Formulario/formularioNuevo.js?vue&type=script&lang=js&external"
export * from "../../components/Formulario/formularioNuevo.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports